define([
	"dojo/_base/declare",
	"csi/action/Controller"
], function(declare, Controller) {

	return declare(Controller, {
		getOriginalController: function() {
			// summary: return action controller for which this is the proxy
			return this.m_action.m_ac;
		},

		getTrackingId: function() {
			// summary: description for performance tracking
			return this.m_action.m_id + "-" + this.getOriginalController().getTrackingId();
		},

		process: function() {
			// forward action to action controller from calling view
			this.disableActionView(true);

			const acOrig = this.getOriginalController();
			// if proxy action has bNavigate, set it in controller
			if (this.m_action.bNavigate) {
				acOrig.bNavigate = true;
			}

			this.when(acOrig.validate(this), () => {
				acOrig.m_proxy = this;
				acOrig.setProgress();
				acOrig.resumeProcess();
				acOrig.process();
			});
		},

		postProcess: function(/*Boolean*/bStatus) {
			// summary: if action was success and is to be repeated, reset controller and continue;
			// return whether or not dialog is closed
			var acOrig = this.getOriginalController();
			var bEnd = false;

			if (bStatus && this.m_action.m_bRepeat) {
				// reset form, writer
				let {widget} = this;

				// handle the wizard case 
				if (widget.getSelectedPage) {
					widget = widget.getSelectedPage().viewTab;
				}

				widget.resetForm();
			} else if (bStatus === false) {

				if (this.m_action.bNavigate) {
					// reset bNavigate on the original controller
					acOrig.bNavigate = false;
				}

				// reset dialog actions
				this.disableActionView(false);

				// the proxy does not have default way to get good error message, so only display error if there is one;
				// if error somes from server on publish, then regular Controller will output correct error message
				if (this.m_error) {
					this.displayError();
				}
			} else {
				// close dialog unless action failed - reset dialog member to distinguish between cancel action and dialog close button
				acOrig.closeDialog();
				bEnd = true;
			}

			// end tracking for proxy - call explicitly here instead of base class postProcess
			// to skip reporting any status to user; the actual controller will handle that
			this.endProcess();

			return bEnd;
		}
	});
});